module.exports = __webpack_public_path__ + "static/media/img_carrousel01.d7c46e3e.svg";